import HttpClient from './httpClient';
import createInstance from './factory';

const httpClient = createInstance();

export default httpClient;

export { HttpClient };
export type { HttpRequestConfig, HttpResponse } from './httpClient';
